/**
 * GERADO. Não edite à mão.
 *
 * Produzido por `packages/asset-pipeline/src/jewels/emit-jewel-manifest.ts` a
 * partir dos masters em `assets-source/jewels/`, que continuam a ser a única
 * fonte da arte.
 *
 * Regenerar:
 *
 *     pnpm assets:prepare
 *
 * `emit-jewel-manifest.test.ts` compara este ficheiro com o que uma regeração
 * produziria: divergir é teste vermelho, e não uma surpresa em produção.
 *
 * Ele está FORA do Biome, como o manifesto de skins e pela mesma razão: o
 * formatador quer uma forma e este gerador emite `JSON.stringify`, e reproduzir
 * a formatação aqui criaria um segundo sítio onde a FORMA do ficheiro é
 * decidida - a brigar com a prova, que compara texto.
 */

import type { JewelManifest } from './jewel-manifest';

export const GENERATED_JEWEL_MANIFEST = {
  "manifestVersion": 1,
  "entries": [
    {
      "definitionId": "jewel_atomic_bomb",
      "assetKey": "jewel_atomic_bomb",
      "socketMode": "socketed",
      "visualShape": "orb",
      "master": "jewel_atomic_bomb.png",
      "masterSha256": "6dccc65c9429f1deb0d3f548d849efb6f4bfc1ae322bab6eaaffb9c47e6f6d61",
      "file": "jewels/jewel_atomic_bomb.png",
      "sha256": "67496b310bc0da8366cb14085aa11f01be0cc00eb8d30942144ee18e8b592f28",
      "width": 256,
      "height": 256,
      "maskFile": "jewels/jewel_atomic_bomb.mask.png",
      "maskSha256": "c92b6f49c93c24b937e5902f08e3d58ec811d581640d78cfdd616713af9c00e7"
    },
    {
      "definitionId": "jewel_attack_speed",
      "assetKey": "jewel_attack_speed",
      "socketMode": "socketed",
      "visualShape": "orb",
      "master": "jewel_attack_speed.png",
      "masterSha256": "96e98a19f98de71951a112c8009442b83caac9c1b19fb15db92834ef248bf989",
      "file": "jewels/jewel_attack_speed.png",
      "sha256": "10ceeea7d9fb4a0ed36658912ad9a43b9ab7b074bd84c2f5f5772e9f57fbe5f8",
      "width": 256,
      "height": 256,
      "maskFile": "jewels/jewel_attack_speed.mask.png",
      "maskSha256": "0d4c79b0c92b8e91ac7bcd38da687016897b22efea7ea99ecd1961b8c90134c5"
    },
    {
      "definitionId": "jewel_blade_cut",
      "assetKey": "jewel_blade_cut",
      "socketMode": "socketed",
      "visualShape": "orb",
      "master": "jewel_blade_cut.png",
      "masterSha256": "b46f142d6100b863d939618dbf73895155524dd34a6c63d9e38a706e5bd2a432",
      "file": "jewels/jewel_blade_cut.png",
      "sha256": "e0979e4ef7158e891e8614c660bf400ed2a352193e8ca26e081fa65b8aef5bc5",
      "width": 256,
      "height": 256,
      "maskFile": "jewels/jewel_blade_cut.mask.png",
      "maskSha256": "8d241179bad3ab526c2585088416cd8a675723661f8a735811c932de60459d76"
    },
    {
      "definitionId": "jewel_bleeding",
      "assetKey": "jewel_bleeding",
      "socketMode": "socketed",
      "visualShape": "orb",
      "master": "jewel_bleeding.png",
      "masterSha256": "4b1e30911e37ac1324c57bbb5aae7ad752fadd7559a1f197dbe3b7fb22568753",
      "file": "jewels/jewel_bleeding.png",
      "sha256": "7281cccc1c96249511ad9a4d9635a81f0255e3f0e9f050337457200bfc3d55e8",
      "width": 256,
      "height": 256,
      "maskFile": "jewels/jewel_bleeding.mask.png",
      "maskSha256": "39cd4108819cd16d4bf4165ca66a48e3b443bfd56ed47fe2d3433d419a00276f"
    },
    {
      "definitionId": "jewel_damage",
      "assetKey": "jewel_damage",
      "socketMode": "socketed",
      "visualShape": "orb",
      "master": "jewel_damage.png",
      "masterSha256": "07e903eae02d5f97460823d870c1da0763059d12775f78db255b8ef849437fee",
      "file": "jewels/jewel_damage.png",
      "sha256": "4ee3adfdafcb5c90b195e3b87f152707e06f70be21d768126fcf521e1dc2b914",
      "width": 256,
      "height": 256,
      "maskFile": "jewels/jewel_damage.mask.png",
      "maskSha256": "e3dec9492e427aef3a7c7a082bb86145ef8ac9a63b55cdfa6022442247dfc748"
    },
    {
      "definitionId": "jewel_damage_reduction",
      "assetKey": "jewel_damage_reduction",
      "socketMode": "socketed",
      "visualShape": "orb",
      "master": "jewel_damage_reduction.png",
      "masterSha256": "d281bb6c9c373199e53188ccb08a5aa1b518744866bc810e80a43619e0b2b75f",
      "file": "jewels/jewel_damage_reduction.png",
      "sha256": "fd3fe2cda6649775d2e74bc3a2dd94c73d2c162d4f0be7c9204f1a536a381b4a",
      "width": 256,
      "height": 256,
      "maskFile": "jewels/jewel_damage_reduction.mask.png",
      "maskSha256": "99e5a6eee699f8ee6bac1df729c86eb233cb7d76a7bf51bd5bae076947225271"
    },
    {
      "definitionId": "jewel_damage_reflection",
      "assetKey": "jewel_damage_reflection",
      "socketMode": "socketed",
      "visualShape": "orb",
      "master": "jewel_damage_reflection.png",
      "masterSha256": "51588eed5a6c040b3ba04a07934f47c80145382b1aaf98d10879b48b4fe07ce9",
      "file": "jewels/jewel_damage_reflection.png",
      "sha256": "9871d0c79124b2c874a38eed66334aaa03e68b06a91d2705960360290327e43a",
      "width": 256,
      "height": 256,
      "maskFile": "jewels/jewel_damage_reflection.mask.png",
      "maskSha256": "4aeb0a9f4eba69f5ac2c13b25ee7f81c2a1b17866047db1ca6c268a9c0628b3e"
    },
    {
      "definitionId": "jewel_lifesteal",
      "assetKey": "jewel_lifesteal",
      "socketMode": "socketed",
      "visualShape": "orb",
      "master": "jewel_lifesteal.png",
      "masterSha256": "da6cf135bd7411480c237ca51f4e28758c86e9f8b3623cef6e9fc0684693cc63",
      "file": "jewels/jewel_lifesteal.png",
      "sha256": "554b99e44e7c93acd755c94a7a478ca5d0e73a3322f06877bdfbb236cf15a42e",
      "width": 256,
      "height": 256,
      "maskFile": "jewels/jewel_lifesteal.mask.png",
      "maskSha256": "ff3b18ec09e7de5053b8da18d1ec4733471bdba43bdbc9b9faecb8b196a7a94d"
    },
    {
      "definitionId": "jewel_max_health",
      "assetKey": "jewel_max_health",
      "socketMode": "socketed",
      "visualShape": "orb",
      "master": "jewel_max_health.png",
      "masterSha256": "761f3fdc4a98244bf6ec2fbeaffddf04ca9d6a54e4de1d34e19eadeb4b0efd64",
      "file": "jewels/jewel_max_health.png",
      "sha256": "46b187f45ccbdf35412cf40eb3b70a51cf8440aca117be27b5a80395bf730f2a",
      "width": 256,
      "height": 256,
      "maskFile": "jewels/jewel_max_health.mask.png",
      "maskSha256": "bc40459a91e623852f69545d297a1e48b63c716bf8e21a7733f89984faa4e18d"
    },
    {
      "definitionId": "jewel_missile",
      "assetKey": "jewel_missile",
      "socketMode": "socketed",
      "visualShape": "orb",
      "master": "jewel_missile.png",
      "masterSha256": "4b4007d596a2645d93b8de8e15a99a03e3ec2e6e06a9c7a63ce95ed2f14fcaa2",
      "file": "jewels/jewel_missile.png",
      "sha256": "6b01422e66c34c94901cc17dd53b0b19a8af8e9be0db1a37d0408dca881cbd49",
      "width": 256,
      "height": 256,
      "maskFile": "jewels/jewel_missile.mask.png",
      "maskSha256": "dc788bf2f72caaf7822a8d98a8545d03e754951a50a7684aac6c54e02813c926"
    },
    {
      "definitionId": "jewel_move_speed",
      "assetKey": "jewel_move_speed",
      "socketMode": "socketed",
      "visualShape": "orb",
      "master": "jewel_move_speed.png",
      "masterSha256": "3154fe3ac63acfbb8b2902a0826d119e1e9688d264bd656b8eaeab41ee54fac0",
      "file": "jewels/jewel_move_speed.png",
      "sha256": "57319e8a993db4313e7953326a211c2756ab2dc4d32af7b383512028f6615c23",
      "width": 256,
      "height": 256,
      "maskFile": "jewels/jewel_move_speed.mask.png",
      "maskSha256": "3300149e612fadf7509544f5715e898bcac107125697b24420b67a56a7516d5d"
    },
    {
      "definitionId": "jewel_poison",
      "assetKey": "jewel_poison",
      "socketMode": "socketed",
      "visualShape": "orb",
      "master": "jewel_poison.png",
      "masterSha256": "7a0a0d4d1fd87fa2ff79ae7e2b69f532f19666ffe48731bdeccf7a809304f499",
      "file": "jewels/jewel_poison.png",
      "sha256": "40bd4d9f1e14921e78b92922af1ee937b8f63852de2016d2cac5dfbeecf5ae5c",
      "width": 256,
      "height": 256,
      "maskFile": "jewels/jewel_poison.mask.png",
      "maskSha256": "1f7995dd29e963a9c459595023d7f8200cc5b6c1d991afd64062986468552bec"
    },
    {
      "definitionId": "jewel_primordial",
      "assetKey": "jewel_primordial",
      "socketMode": "sovereign",
      "visualShape": "silhouette",
      "master": "jewel_primordial.png",
      "masterSha256": "d4590a0f002566bbe6d62da49963554f4fa5fd70f8544baf0dfeb473b18fdec7",
      "file": "jewels/jewel_primordial.png",
      "sha256": "408d8554e3dc375513a5f89263a7a0d759be86b4653563c8c0707e55d5db2dde",
      "width": 256,
      "height": 256,
      "maskFile": "jewels/jewel_primordial.mask.png",
      "maskSha256": "76480c93b6c9e78bc32cc3b9c833d5b791a3bf806811bb76b313be02f7402514"
    },
    {
      "definitionId": "jewel_regeneration",
      "assetKey": "jewel_regeneration",
      "socketMode": "socketed",
      "visualShape": "orb",
      "master": "jewel_regeneration.png",
      "masterSha256": "84940bed806b56cc70abed0127cb94b1ebae2e990bcbb02bed380ac6ad39efc5",
      "file": "jewels/jewel_regeneration.png",
      "sha256": "4f559ded4414031de72f2bc1fdb1dfb8e344a8639dc4aaee0772a51e4263ecc5",
      "width": 256,
      "height": 256,
      "maskFile": "jewels/jewel_regeneration.mask.png",
      "maskSha256": "2df3f51e31d05eeccbe46388426f73fca3d3c0d6636a82169c4945f8819c3c2c"
    },
    {
      "definitionId": "jewel_saw",
      "assetKey": "jewel_saw",
      "socketMode": "socketed",
      "visualShape": "orb",
      "master": "jewel_saw.png",
      "masterSha256": "bd240685e7d389eb8b408bd4f020043fafa19016547acb02a32d072fb5532525",
      "file": "jewels/jewel_saw.png",
      "sha256": "4ef620caf6cf09159a76ba0cb7f7980548d186ec76768b25132b54f06476ce41",
      "width": 256,
      "height": 256,
      "maskFile": "jewels/jewel_saw.mask.png",
      "maskSha256": "e5fede03f89fc5db0789cac8a6b4cf978f3519d46a935701d4cffdc5ad5e3ccd"
    }
  ]
} as const satisfies JewelManifest;
